module.exports = __webpack_public_path__ + "static/media/pedra-deck-majik.dd2e0598.png";